export default __webpack_public_path__ + "static/media/logo.d8bf31d8.png";